import React, { useEffect, useState } from 'react'
import './collections-landing.styles.scss';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import CollectionsList from './collections-list.component';
import CollectionsForm from './collections-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useSelector } from 'react-redux';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { properCase } from '@/utils/properCase';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';

const CollectionsLandingPage = ({ gameElements, gameData }) => {

    const membership = useSelector(state => state.userData.membership);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ showUpgradeModal, setShowUpgradeModal ] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        checkMembership();
    }, [])

    function checkMembership() {
        const element = 'collections'
        const res = testMemberRestrictions({'gameData': gameData, 'membership': membership, 'element': element})
        // console.log(res);

        if (res.disabled) {
            let message = ''
            const planRest = membershipRestrictions[membership.membership];
            if (res.disabledReason.includes(element)) {
                message = `While using the ${planRest.title}, you are not able to access ${properCase(element)}.`;
            }
            setShowUpgradeModal(message)
        }
    }

    return (
        <div className={`collections-landing ${screenSize}`}>
            <div className='g-card collections-card'>
                <BackButton cancel={() => navigate(-1)} />
                <div className="g-space-1"></div>
                <div className='card-title'>
                    <ImageContainer 
                        src='/images/icons/collections.png' 
                        alt='collections icon' 
                        className='head-icon' />
                    Create and Edit Collections
                </div>
                <hr />
                <div className='collections-landing-content'>
                    <Routes>
                        <Route path='' element={
                            <CollectionsList 
                                gameElements={gameElements} 
                                gameData={gameData} />
                        }></Route>
                        <Route path='create' element={
                            <CollectionsForm 
                                gameElements={gameElements} 
                                gameData={gameData} />
                        }></Route>
                        <Route path='edit/:collectionPath' element={
                            <CollectionsForm 
                                gameElements={gameElements} 
                                gameData={gameData} />
                        }></Route>
                        <Route path="*" element={
                            <Navigate replace to="/404" />
                        } />
                    </Routes>
                </div>
            </div>
            <UpgradeRequiredModal
                show={showUpgradeModal}
                cancel={() => setShowUpgradeModal(null)}
                message={showUpgradeModal}
            />
        </div>
    )
}

export default CollectionsLandingPage